<template>
  <div class="financial-overview">
    <div class="overview-grid">
      <Balances />
      <LastReleases />
      <BillsToPay @pay="handleToPay" @handle_to_releases="handleToReleases" />
      <BillsToReceive
        @pay="handleToPay"
        @handle_to_releases="handleToReleases"
      />
    </div>
  </div>
</template>

<script>
import Balances from "./Overview/Balances";
import BillsToPay from "./Overview/BillsToPay";
import BillsToReceive from "./Overview/BillsToReceive";
import LastReleases from "./Overview/LastReleases";

export default {
  name: "Overview",
  components: {
    Balances,
    BillsToPay,
    BillsToReceive,
    LastReleases,
  },
  methods: {
    handleToReleases(params) {
      if (params) {
        let { launch } = params;
        this.$emit("handle_to_releases", { launch });
      } else {
        this.$emit("handle_to_releases");
      }
    },
    handleToPay(item) {
      this.$emit("pay", item);
    },
  },
};
</script>

<style scoped>
.financial-overview {
  padding: 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
}

.overview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .financial-overview {
    padding: 16px;
  }

  .overview-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
</style>